import React from 'react'
import { FormattedMessage } from 'react-intl'

import './Header.scss'
import Link from '../Link/Link'
import Logo from '../../assets/logo.png'

class Header extends React.Component {
  changeLang = lang => {
    if (lang === 'en') {
      const newPath = `${window.location.origin}/en${window.location.pathname}`
      window.location = newPath
    } else if (lang === 'fr') {
      const newPath = `${window.location.origin}${window.location.pathname.replace('/en', '')}`
      window.location = newPath
    }
  }

  render() {
    return (
      <div className="row no-gutters align-items-center mt-4">
        <div className="col-12 col-lg-2 pr-0 pr-lg-3 d-flex justify-content-center">
          <Link to="/">
            <img src={Logo} alt="Logo Banoi" width="150" height="150" />
          </Link>
        </div>

        <div className="menu-items text-center text-lg-left col-12 col-lg-8 mt-3 mb-3">
          <div className="row">
            <Link to="/story" activeClassName="active-link" className="col text-center">
              <FormattedMessage id="headerStory" />
            </Link>
            <Link to="/menu" activeClassName="active-link" className="col text-center">
              MENU
            </Link>
            <Link to="/caterer" activeClassName="active-link" className="col text-center">
              TRAITEUR
            </Link>
            <Link to="/press" activeClassName="active-link" className="col text-center">
              PRESSE
            </Link>
            <Link to="/order" activeClassName="active-link" className="col text-center">
              COMMANDE
            </Link>
          </div>
        </div>

        <div className="d-none d-lg-block col-2" />

        {/* <div className="d-none d-lg-block col-2">
          <span
            className={classNames('clickable mr-3', { underline: 'fr' === this.props.locale })}
            onClick={this.changeLang.bind(this, 'fr')}
          >
            FR
          </span>
          &#9679;
          <span
            className={classNames('clickable ml-3', { underline: 'en' === this.props.locale })}
            onClick={this.changeLang.bind(this, 'en')}
          >
            EN
          </span>
        </div> */}
      </div>
    )
  }
}

export default Header



// WEBPACK FOOTER //
// ./src/components/Header/Header.js